export default {
    car_year: 'Year',
    car_make: 'Make',
    car_model: 'Model',
    car_price: 'SellingPrice',
    vin: 'VIN',
    msrp: 'MSRP',
    carfax_link: 'Carfax History URL',
    interior_color: 'InteriorColor',
    exterior_color: 'ExteriorColor',
    engine_type: 'Engine_Description',
    fuel_type: 'Fuel_Type',
    mpg_city: 'CityMPG',
    mpg_highway: 'HighwayMPG',
    mileage: 'Miles',
    transmission: 'Transmission_Description',
    drivetrain: 'Drivetrain',
    body_style: 'Body',
    vehicle_link: 'URL',
}
